import React, { ReactNode } from 'react';

interface AvatarWithInitialsProps {
  initials: string;
  icon?: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'size-4',
  md: 'size-6',
  lg: 'size-8',
};

const AvatarWithInitials = ({
  initials,
  icon,
  size = 'md',
  className = '',
}: AvatarWithInitialsProps) => {
  return (
    <div
      className={`${sizeClasses[size]} relative bg-secondary-300 rounded-full text-white text-center align-middle leading-6 flex items-center justify-center ${className}`}
    >
      {initials}
      {icon}
    </div>
  );
};

export default AvatarWithInitials; 